import { SignupStep } from "pages/files/Signup";
import { SVG } from "ui";
import { CustomComponentProps } from "utils/types/generalTypes";

export type SignupProgressNavProps = CustomComponentProps & {
    steps: SignupStep[];
    currentStep: number;
};

const SignupProgressNav = ({
    steps,
    currentStep,
    className,
    style
}: SignupProgressNavProps) => {
    // const steps = [
    //     { id: "step-dot-1", svg: "user", class: "is-first", step: 0 },
    //     { id: "step-dot-2", svg: "verify", class: "is-second", step: 16.5 },
    //     { id: "step-dot-3", svg: "globe", class: "is-third", step: 33 },
    //     { id: "step-dot-4", svg: "topic", class: "is-fourth", step: 49.5 },
    //     { id: "step-dot-5", svg: "follow", class: "is-fifth", step: 66 },
    //     { id: "step-dot-6", svg: "lock", class: "is-sixth", step: 82.5 },
    //     { id: "step-dot-7", svg: "flag", class: "is-seventh", step: 100 }
    // ];

    const width = `${steps[currentStep].step}%`;

    return (
        <div className={`process-bar-wrap ${className}`} style={style}>
            <div className="process-bar">
                <div className="progress-wrap">
                    <div className="track"></div>
                    <div className="bar" style={{ width: width }}></div>

                    {steps.map((step, index) => (
                        <div
                            key={step.id}
                            className={`dot ${step.class} ${currentStep >= index ? "is-active" : ""} ${currentStep == index ? "is-current" : ""}`}
                        >
                            <SVG
                                svg={step.svg}
                                size={16}
                                className="process-bar-svg"
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default SignupProgressNav;
